import { database } from '@app/firebase';
import LikeButton from '@components/buttons/LikeButton';
import UserContext from '@context/UserContext';
import useCollection from '@hooks/useCollection';
import Sentry from '@integrations/Sentry';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TaggedProduct from '@ui/components/tagged-product/TaggedProduct';
import onSavedClickProduct from '@utils/clickHandlers/onSavedClickProduct';
import { productToSegmentEventData } from '@utils/segmentAnalytics';
import { collectionGroup, query, where } from 'firebase/firestore';
import React, { useContext, useMemo } from 'react';

import useStyles from './TaggedProducts.style';

type TaggedProductsProps = {
  photo: guesthouse.Photo;

}

const TaggedProducts: React.FC<TaggedProductsProps> = (props) => {
  const { photo } = props;
  const { classes, theme } = useStyles();
  const userContext = useContext<UserContext>(UserContext);

  const { collection } = useCollection(
    photo?.docID && query(collectionGroup(database, 'productTags')
      ,where('photo.docID', '==', photo?.docID)),
    photo?.docID,
  );

  const productTags: guesthouse.Product[] = useMemo(() => {
    if (collection?.docs?.length) {
      return collection.docs.map(pt => pt.data().product as guesthouse.Product);
    } else {
      return [];
    }
  }, [collection]);

  if (productTags?.length) {
    return (
      <Box>
        <Typography
          className={classes.wrapper}
        >
          {`${productTags.length} ${productTags.length === 1 ? 'product' : 'products'} available`}
        </Typography>
        {productTags.map(product => {
          return (
            <TaggedProduct
              key={product.docID}
              defaultProductImage="/images/misc/product-default.png"
              product={product}
              style={{
                marginBottom: theme.spacing(1),
              }}
              renderActions={() => {
                const saved = userContext.savedProducts?.ids.indexOf(product.docID) > -1;

                return (
                  <LikeButton
                    enabled={saved}
                    large={true}
                    onClick={async (e) => onSavedClickProduct(userContext, saved, product as guesthouse.Product, e)}
                  />
                );
              }}
              onClick={(_, product) => {
                try {
                  window.analytics?.track('Product Clicked', productToSegmentEventData(product));
                } catch (e) {
                  Sentry.captureException(e);
                }
              }}
            />
          );
        })}
      </Box>
    );
  }

  return (
    <Typography
      className={classes.wrapper}
    >
      No products shown
    </Typography>
  );
};

export default TaggedProducts;
